// Lightweight GTM dataLayer event helper.
// NEVER pass names, phone numbers, emails, messages or health details here.

type Payload = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    dataLayer?: Payload[];
  }
}

export const track = (event: string, params: Payload = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    page_path: window.location.pathname,
    ...params,
  });
};

export const trackCall = (source: string) => track("click_call", { source });
export const trackWhatsApp = (source: string) => track("click_whatsapp", { source });
export const trackDirections = (source: string) => track("click_directions", { source });
export const trackFormSubmit = (formName: string, treatment?: string) =>
  track("form_submit", { form_name: formName, treatment });
